const GENERAL_SETTINGS = {
  GENERAL_PAGE_HEADER_TITLE: 'General settings',
  GENERAL_PAGE_HEADER_DESCRIPTION:
    'Website settings. Note that the settings of each website are separate.',
  GENERAL_PAGE_LOGO_UPLOAD_SUBTITLE: 'The maximum logo size is 500 KB',
  GENERAL_PAGE_LOGO_UPLOAD_BTN: 'Upload the website logo',
  GENERAL_PAGE_REMOVE_LOGO: 'Remove Logo',
  GENERAL_PAGE_GUIDE_TOOLTIP:
    'If you define a personalized logo for your website, the avatar of users who send messages from the website will be displayed in the web app with your defined logo.',

  GENERAL_PAGE_SWITCH_1_TITLE: 'View typed words',
  GENERAL_PAGE_SWITCH_1_DESC:
    "You can see the user's typed sentences before sending them to you",
  GENERAL_PAGE_SWITCH_2_TITLE: 'Send voice from the widget',
  GENERAL_PAGE_SWITCH_2_DESC:
    'Ability to send voice messages to users from the widget',
  GENERAL_PAGE_SENDFILE_SWITCH_TITLE: 'Access to sending file',
  GENERAL_PAGE_SENDFILE_SWITCH_DESC: 'Access to sending file in widget',
  GENERAL_PAGE_SWITCH_3_TITLE: "Hide text 'Powered by Raychat'",
  GENERAL_PAGE_SWITCH_3_DESC: "Hide 'Powered by RayChat' in the chat widget",
  GENERAL_PAGE_SWITCH_4_TITLE:
    'Submit the form to receive information from the user',
  GENERAL_PAGE_SWITCH_4_DESC: 'Receive email or phone number from the user',
  GENERAL_PAGE_FORM_SETTINGS_BTN: '(Settings)',
  GENERAL_PAGE_FORM_MODAL_SUBMIT_BTN: 'Submit',
  GENERAL_PAGE_FORM_MODAL_CANCEL_BTN: 'Cancel',
};

export default GENERAL_SETTINGS;
